import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import MarathonTicketListContainer from "@jumbo/Dashboards/Tests/MarathonTicketListContainer";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box, Button, Typography } from "@material-ui/core";
import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../services/auth/jwt/config";
import { useParams } from "react-router";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  {
    label: <IntlMessages id={"pages.marathonEveventsPage"} />,
    link: "/marathonDanie",
  },
  { label: <IntlMessages id={"pages.marathonTickets"} />, isActive: true },
];

const MarathonTicketList = () => {
  const { id, eventName } = useParams();

  const handleDownloadAnswers = async () => {
    const fileUrl = `${baseUrl}marathonDanaie/eventAnswer/report/${id}`;
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const contentDisposition = response.headers["content-disposition"];
      let filename = "Participants.xlsx";
      if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = decodeURIComponent(matches[1].replace(/['"]/g, ""));
        }
      }
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <PageContainer
      heading={<IntlMessages id="pages.marathonTickets" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IntlMessages id="pages.marathonTickets.description" />
            <Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<ArrowDownwardIcon />}
                onClick={handleDownloadAnswers}
              >
                پاسخ کاربران
              </Button>
            </Box>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <Typography variant="h4" gutterBottom align="center" style={{marginBottom:'20px'}}>
              لیست شرکت کنندگان ماراتون {eventName}
            </Typography>
            <MarathonTicketListContainer eventId={id} />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default MarathonTicketList;
